import type { Dict } from "./pl.js";

export const es: Dict = {
  navCats: "Categorías",
  navHow: "Cómo funciona",
  navOps: "Para profesionales",
  navPrice: "Precios",
  navContact: "Contacto",
  navBook: "Demo del panel profesional",
  pill: "La plataforma de reservas para negocios de servicios",
  title1: "Tus servicios.",
  title2: "Se reservan solos.",
  sub: "b00k reúne todos los calendarios de tus servicios — habitaciones, coches, citas — en un único sistema de reservas. Tus clientes reservan solos por web y chat, y el sistema vigila los horarios y bloquea los solapamientos.",
  ctaBook: "Crear cuenta profesional",
  ctaOperator: "Ver la vista de cliente",
  heroMeta: "TU-EMPRESA.B00K.ONLINE · CADA NEGOCIO TIENE SU PROPIO SUBDOMINIO",
  cardChip: "Confirmada",
  cardNote: "Las reservas entran solas — desde la web y el chat — y bloquean la agenda al instante.",
  catsKick: "CATEGORÍAS DE SERVICIOS",
  catsTitle: "Qué puedes gestionar con b00k",
  catsSub: "Una plataforma para todos tus servicios. Los que van por horas se encadenan; habitaciones y coches se reservan en paralelo, por días.",
  cat1t: "Habitaciones",
  cat1d: "Habitaciones y apartamentos para una o varias noches. Varias habitaciones se reservan en paralelo para las mismas fechas.",
  cat2t: "Coches",
  cat2d: "Urbanos y SUV por días. El calendario de disponibilidad vigila entregas y devoluciones.",
  cat3t: "Ocio",
  cat3d: "Sauna, spa, kayaks. Reserva a una hora concreta, con duración definida.",
  cat4t: "Peluquería",
  cat4d: "Corte y color. Eliges la hora — el sistema bloquea exactamente lo que dura el servicio.",
  cat5t: "Estética",
  cat5d: "Manicura y masajes. Combínalos con otros servicios — las duraciones se funden en un solo bloque.",
  cat6t: "Salud",
  cat6d: "Consultas y pruebas a hora fija. El calendario de la consulta se mantiene solo.",
  cat7t: "Taller",
  cat7d: "Coche, bici u ordenador portátil — lo cubrimos todo.",
  cat8t: "Clases particulares",
  cat8d: "Clases de idiomas o de piano — organízalas en nuestra plataforma.",
  cat9t: "Otros",
  cat9d: "Las particularidades de tu sector + nuestra experiencia = éxito.",
  howKick: "CÓMO FUNCIONA",
  howTitle: "Tres pasos, cero llamadas",
  s1t: "Añade servicios y recursos",
  s1d: "Enumera habitaciones, coches y citas con sus duraciones y precios. El sistema verifica cada cuenta al registrarse — la tuya y la de tus clientes.",
  s2t: "Los clientes reservan solos",
  s2d: "Por web o chat — WhatsApp y Messenger. Las duraciones se suman, las habitaciones se reservan en paralelo y solo se muestran los huecos realmente libres.",
  s3t: "El sistema vigila la agenda",
  s3d: "Al confirmar, el hueco queda bloqueado — dos personas nunca pueden reservar el mismo servicio a la misma hora. Cancelaciones y cambios incluidos.",
  newChip: "Novedad",
  chatLine: "Tus clientes pueden reservar chateando — por WhatsApp o Messenger.",
  opsKick: "PARA PROFESIONALES",
  opsTitle: "Tu agenda trabaja para ti",
  opsSub: "Habitaciones, coches y citas en un solo calendario. Los solapamientos se bloquean solos, las reservas por chat entran automáticamente y ves ocupación e ingresos en directo.",
  opsCta: "Ver el panel profesional",
  f1: "Calendario del día y ocupación de recursos en una vista",
  f2: "Bloqueo automático de solapamientos",
  f3: "Reservas desde la web y el chat — WhatsApp / Messenger",
  f4: "Clientes, notas de reserva e indicadores",
  priceKick: "PRECIOS",
  priceTitle: "Tan simple como una reserva",
  month: "mes",
  recommended: "Recomendado",
  soon: "DISPONIBLE PRONTO",
  custom: "A medida",
  opsSuffix: "empleados",
  priceNote: "El precio mensual depende de cuántos empleados tienen acceso al panel.",
  t1f1: "Calendario y reservas online",
  t1f2: "Chat de WhatsApp / Messenger",
  t1f3: "Clientes, notas y recordatorios",
  t2f1: "Todo lo de SOLO",
  t2f2: "Recursos y servicios sin límite",
  t2f3: "Informes e indicadores de ocupación",
  t3f1: "Todo lo de TEAM",
  t3f2: "Turnos y roles de los empleados",
  t3f3: "API e integraciones",
  t4f1: "Todo lo de GROUP",
  t4f2: "Acompañamiento en la puesta en marcha y SLA",
  t4f3: "Contrato y facturación a medida",
  conKick: "CONTACTO Y CÓMO LLEGAR",
  conTitle: "Tu ubicación, su camino",
  dirKick: "CÓMO LLEGAR — ASÍ LO VERÁN TUS CLIENTES",
  dir1: "En coche: carretera nacional 3 desde Jelenia Góra, salida Szklarska Poręba Centrum, luego 5 minutos por la calle Zdrojowa.",
  dir2: "En tren: estación de Szklarska Poręba Górna, 12 minutos a pie hacia el centro.",
  dir3: "Aparcamiento gratuito para clientes — sin coste ni reserva.",
  footUser: "Vista de cliente",
  footOp: "Panel profesional",

  wizTitle: "Crear cuenta profesional",
  wizSub: "Siete pasos. Al terminar tendrás tu subdominio y un panel listo para usar.",
  wizStep1: "Empresa",
  wizStep2: "Subdominio",
  wizStep3: "Sectores",
  wizStep4: "Plan",
  wizStep5: "Administrador",
  wizStep6: "Pagos",
  wizStep7: "Resumen",
  wizNext: "Siguiente",
  wizBack: "Atrás",
  wizFinish: "Crear cuenta",
  fCompany: "NOMBRE DE LA EMPRESA",
  fNip: "NÚMERO FISCAL (NIP)",
  fPhone: "TELÉFONO",
  fAddress: "DIRECCIÓN",
  fSlug: "SUBDOMINIO",
  slugHint: "La dirección donde tus clientes reservarán tus servicios.",
  slugChecking: "Comprobando disponibilidad…",
  slugFree: "El subdominio está libre.",
  slugTaken: "Este subdominio ya está ocupado.",
  slugInvalid: "Subdominio: 3–63 caracteres, minúsculas, cifras y guion (ni al principio ni al final).",
  industriesHint: "Elige los sectores que atiendes. Podrás añadir más desde el panel.",
  planHint: "Cambias de plan cuando quieras — sin perder datos.",
  fName: "NOMBRE Y APELLIDOS",
  fEmail: "CORREO ELECTRÓNICO",
  fPass: "CONTRASEÑA (MÍN. 8 CARACTERES)",
  fPass2: "REPITE LA CONTRASEÑA",
  fTerms: "Acepto las condiciones de b00k.online y consiento el tratamiento de datos para gestionar las reservas.",
  payTitle: "Pagos de clientes",
  payHint: "Opcional. Puedes cobrar online al confirmar la reserva.",
  payEnable: "Aceptar pagos online",
  payMethods: "MÉTODOS DE PAGO",
  sumTitle: "Resumen",
  sumCompany: "EMPRESA",
  sumSub: "SUBDOMINIO",
  sumIndustries: "SECTORES",
  sumPlan: "PLAN",
  sumAdmin: "ADMINISTRADOR",
  sumPayments: "PAGOS",
  yes: "Sí",
  no: "No",
  doneTitle: "Tu cuenta profesional está lista",
  doneSub: "Tu subdominio ya funciona. Entra en el panel y añade servicios — las reservas empiezan de inmediato.",
  doneOpen: "Abrir el panel profesional",
  doneBooking: "Ver la página de reservas",
  companyProofOk: "Sesión iniciada como administrador de la empresa:",
  companyLoginOther: "Iniciar sesión con otra cuenta",
  errGeneric: "No hemos podido crear la cuenta. Revisa los datos e inténtalo de nuevo.",
};
